import { render, staticRenderFns } from "./SavusaunaHours.vue?vue&type=template&id=be0a11fa&scoped=true"
import script from "./SavusaunaHours.vue?vue&type=script&lang=js"
export * from "./SavusaunaHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0a11fa",
  null
  
)

export default component.exports